import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Menu, { MenuItem } from "../../menu/Menu";
import { LogoDescription, LogoText, LogoTextEm, LogoWrapper, MainSideBarWrapper, MenuGroup, MenuGroupContent, MenuGroupTitle, MenuItemText, MenuItemWrapper, MenuWrapper } from "./MainSideBar.styled";
import ViewStateService from "../../../../services/view-state/ViewStateService";
import SessionService from "../../../../services/session/SessionService";

interface MainSideBarProps {

}

const MainSideBar: React.FC<MainSideBarProps> = (props)=> {
    let menu = Menu.getMainMenu();
    let location = useLocation();
    let navigate = useNavigate();
    let [ searchParams ] = useSearchParams();

    let profile = SessionService.getInstance().getCurrentUserProfile();
    let permissions = SessionService.getInstance().getCurrentUserPermissions();
    let tenantFeatures = SessionService.getInstance().getCurrentTenantFeatures();
    for(let group of menu.groups) {
        if (group.filterTenantFeatures && !tenantFeatures.includes(group.permission)) {
            (group as any).hide = true;
        }
    }
    if (!profile.admin) {
        for(let group of menu.groups) {
            if (!permissions.includes(group.permission)) {
                (group as any).hide = true;
            }
            let visitMenuItem = (menuItem: MenuItem)=> {
                if (menuItem.permission && !permissions.includes(menuItem.permission)) {
                    (menuItem as any).hide = true;
                }
            };
            for (let menuItem of group.items) {
                visitMenuItem(menuItem);
            }
        }
    }

    if (!searchParams.get('showHidden')) {
        let tenantNo = profile.tenantNo;
        for(let group of menu.groups) {
            for (let menuItem of group.items) {
                if ((menuItem as any).dataSummaryTenantOnly && tenantNo !== "ADMIN") {
                    (menuItem as any).hide = true;
                }
            }
        }
    }

    let onMenuItemClick = (menuItem: MenuItem)=> {
        navigate(menuItem.path);
        ViewStateService.getInstance().setStatusBarTitle(menuItem.name);
    }

    let isSelected = (menuItem: MenuItem)=> {
        let pathname = location.pathname;
        if (pathname.startsWith(menuItem.path)) {
            ViewStateService.getInstance().setStatusBarTitle(menuItem.name);
            return true;
        }
        return false;
    }

    return (
        <MainSideBarWrapper>
            <LogoWrapper>
                <LogoText><LogoTextEm>W</LogoTextEm>inch <LogoTextEm>L</LogoTextEm>ink <LogoTextEm>S</LogoTextEm>ystem</LogoText>
                <LogoDescription>智能卷扬机互联系统</LogoDescription>
            </LogoWrapper>

            <MenuWrapper>
                {
                    menu.groups.filter(group=> !(group as any).hide).map((menuGroup)=> {
                        return (
                            <MenuGroup key={menuGroup.name}>
                                <MenuGroupTitle>{menuGroup.name}</MenuGroupTitle>
                                <MenuGroupContent>
                                    {
                                        menuGroup.items.filter(item=> !(item as any).hide).map((menuItem)=> {
                                            return (
                                                <MenuItemWrapper key={menuItem.path} className={isSelected(menuItem) ? "active": ""} onClick={()=> onMenuItemClick(menuItem)}>
                                                    <MenuItemText>{menuItem.name}</MenuItemText>
                                                </MenuItemWrapper>
                                            )
                                        })
                                    }
                                </MenuGroupContent>
                            </MenuGroup>
                        )
                    })
                }
            </MenuWrapper>

        </MainSideBarWrapper>
    )
}

export default MainSideBar;

